import { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";
import { useContent } from "../../context/ContentContext";
import { Reveal } from "./Reveal";
import { SectionBg } from "./SectionBg";

const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(value.replace(/[0-9]/g, "0"));

  useEffect(() => {
    if (!inView) return;
    const num = parseInt(value.replace(/\D/g, ""), 10);
    if (isNaN(num)) { setDisplay(value); return; }
    const suffix = value.replace(/[0-9]/g, "");
    let cur = 0;
    const step = Math.max(1, Math.ceil(num / 40));
    const id = setInterval(() => {
      cur += step;
      if (cur >= num) { cur = num; clearInterval(id); }
      setDisplay(`${cur}${suffix}`);
    }, 30);
    return () => clearInterval(id);
  }, [inView, value]);

  return <span ref={ref}>{display}</span>;
};

export const Stats = () => {
  const { content } = useContent();
  return (
    <section className="relative overflow-hidden bg-[#050505] py-24 md:py-32 border-b border-white/10" data-testid="stats-section">
      <SectionBg id="stats" />
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-y-12">
          {content.stats.map((s, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}
              className={`px-4 md:px-8 ${i % 3 !== 0 ? "md:border-l border-white/10" : ""} ${i % 2 !== 0 ? "border-l md:border-l border-white/10" : ""}`}>
              <div className="font-serif text-5xl md:text-6xl lg:text-7xl text-white tracking-tight">
                <Counter value={s.value} />
              </div>
              <div className="mt-3 text-[11px] md:text-xs tracking-[0.18em] uppercase text-secondary2 max-w-[16rem]">{s.label}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
